const buttonBaseStyle = {
  display: "flex",
  width: "80%",
  backgroundColor: "#016a29",
  color: "white",
  fontWeight: "bold",
  border: "none",
  fontSize: "15px",
  alignItems: "center",
  justifyContent: "center",
  padding: "2px 10px", // padding: '2px 0',
  height: "40px",
  margin: "5px auto",
  cursor: "pointer"
};

export const remoStyles = {
  container: {
    position: "relative",
    top: "200px",
    width: "90%",
    display: "flex",
    flexDirection: "column",
    fontFamily: "Helvetica, Arial, sans-serif",
    justifyContent: "center",
    margin: "0px auto",
    backgroundColor: "white",
    padding: "20px 0px 25px",
    "@media (minWidth: 1024px)": {
      width: "400px"
    }
  },
  header: {
    display: "flex",
    justifyContent: "center",
    fontSize: "30px",
    paddingLeft: "20px",
    paddingRight: "20px",
    "@media (minWidth: 1024px)": {
      paddingLeft: 0,
      paddingRight: 0
    }
  },
  content: {
    width: "80%",
    margin: "5px auto 10px",
    fontSize: 14,
    flexDirection: "column"
  },
  text: {
    display: "flex",
    justifyContent: "center",
    margin: "10px auto",
    /*margin: '0 auto 10px'*/
    fontSize: "15px",
    width: "80%"
  },
  okButton: buttonBaseStyle,
  checkboxContainer: {
    alignItems: "center",
    display: "flex"
  },
  field: {
    margin: "0 auto 10px",
    fontSize: 14,
    flexDirection: "column"
  },
  input: {
    marginBottom: 20
  },
  label: {
    fontWeight: "bold"
  },
  noData: {
    fontSize: "13px",
    fontStyle: "italic",
    marginBottom: "10px"
  },
  remoCancelButtonStyle: {
    ...buttonBaseStyle,
    backgroundColor: "#444"
  }
};
